import { useState, useEffect, use } from "react";
import { useParams } from "react-router-dom";

import axiosInstance from "../../../api/axios";
import toast from "../../../shared/toast";
import { useNavigate } from "react-router-dom";
import Loading from "../../../shared/Loading";
import MultiSelectWithCheckbox from "../../../shared/MultiSelectWithCheckbox";
import WaitLoading from "../../../shared/WaitLoading";

const UserDetail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [sendingLoading, setSendingLoading] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);

  useEffect(() => {
    setLoading(true);

    const fetchClientData = axiosInstance
      .get(`/api-admin/client/${params.clientId}`)
      .then((response) => {
        const clientData = response.data.result;
        setFormData({
          email: clientData.email || "",
          loginCode: clientData.loginCode || "",
          role: clientData.role || "",
          fullName: clientData.fullName || "",
          phoneNumber: clientData.phoneNumber || "",
        });
        setSelectedCompanies(clientData.selectedCompanies || []);
      })
      .catch((error) => {
        console.error("Error fetching client data:", error);
        if (error.response?.data?.message) {
          toast("error", error.response.data.message);
        }
      });

    const fetchCompaniesData = axiosInstance
      .get(`/api-admin/companies`)
      .then((response) => {
        const clientData = response.data.result;
        if (Array.isArray(clientData)) {
          const companiesData = clientData.map((company) => ({
            value: company.id,
            label: company.name,
          }));
          setCompanies(companiesData);
        }
      })
      .catch((error) => {
        console.error("Error fetching companies data:", error);
        if (error.response?.data?.message) {
          toast("error", error.response.data.message);
        }
      });

    Promise.all([fetchClientData, fetchCompaniesData]).finally(() => {
      setLoading(false);
    });
  }, [params.clientId]);

  const [formData, setFormData] = useState({
    email: "",
    loginCode: "",
    phoneNumber: "",
    role: "",
    fullName: "",
  });

  const { email, loginCode, phoneNumber, role, fullName } = formData;

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

    if (e.target.name === "fullName" && e.target.value.length < 3) {
      setUsernameError(true);
    } else {
      setUsernameError(false);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSendingLoading(true);

    if (!role || !fullName || !phoneNumber || !loginCode || !email) {
      toast("error", "Minden mező kitöltése kötelező!");
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      toast("error", "Érvénytelen e-mail cím!");
      return;
    }

    const userData = {
      email,
      code: loginCode,
      phoneNumber,
      role,
      fullName,
      selectedCompany: selectedCompanies,
    };
    try {
      const response = await axiosInstance.post(
        `/api-admin/client/edit-client/${params.clientId}`,
        userData
      );
      toast("success", response.data.message);
      navigate("/");

      setFormData({
        email: "",
        loginCode: "",
        phoneNumber: "",
        role: "",
        fullName: "",
      });
    } catch (error) {
      console.error("Error posting data:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast("error", error.response.data.message);
      } else {
        toast("error", "Szerver hiba");
      }
    } finally {
      setSendingLoading(false);
    }
  };

  const handleSelectionChange = (selectedValues) => {
    setSelectedCompanies(selectedValues);
  };

  if (sendingLoading) {
    return <WaitLoading />;
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header card-no-border pb-3">
              <h3>Új kliens létrehozása</h3>
            </div>
            {!loading ? (
              <div className="card-body">
                <div className="horizontal-wizard-wrapper">
                  <div className="row g-3">
                    <div className="col-12">
                      <div
                        className="tab-content dark-field"
                        id="horizontal-wizard-tabContent"
                      >
                        <div
                          className="tab-pane fade show active"
                          id="wizard-info"
                          role="tabpanel"
                          aria-labelledby="wizard-info-tab"
                        >
                          <form
                            className="row g-3 needs-validation basic-form"
                            onSubmit={onSubmit}
                          >
                            <div className="col-xl-4 col-sm-6 invalid-border-input">
                              <label
                                className="form-label"
                                htmlFor="customLastname"
                              >
                                Teljes név<span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="fullName"
                                name="fullName"
                                type="text"
                                placeholder="Teljes név megadása"
                                required=""
                                onChange={onChange}
                                value={fullName}
                              />
                            </div>
                            <div className="col-xl-4 col-12">
                              <label
                                className="form-label"
                                htmlFor="customEmail"
                              >
                                Telefonszám
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="phoneNumber"
                                name="phoneNumber"
                                type="text"
                                required=""
                                placeholder="Telefonszám megadása"
                                onChange={onChange}
                                value={phoneNumber}
                              />
                              <div className="valid-feedback">Looks good!</div>
                            </div>
                            <div className="col-xl-4 col-sm-6">
                              <label
                                className="form-label"
                                htmlFor="customFirstname"
                              >
                                Hitelesitési kód
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="loginCode"
                                name="loginCode"
                                type="text"
                                placeholder="Hitelesitési kód megadása"
                                required=""
                                onChange={onChange}
                                value={loginCode}
                              />
                              <div className="valid-feedback">Looks good!</div>
                            </div>
                            <div className="col-xl-4 col-sm-6">
                              <label
                                className="form-label"
                                htmlFor="customFirstname"
                              >
                                Beosztás<span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="role"
                                type="text"
                                placeholder="Beosztás megadása"
                                required=""
                                name="role"
                                onChange={onChange}
                                value={role}
                              />
                              <div className="valid-feedback invalid">
                                Looks good!
                              </div>
                            </div>
                            <div className="col-xl-4 col-sm-6">
                              <label
                                className="form-label"
                                htmlFor="customLastname"
                              >
                                E-mail cím<span className="text-danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="email"
                                name="email"
                                type="email"
                                placeholder="E-mail cím kód megadása"
                                required=""
                                onChange={onChange}
                                value={email}
                              />
                              <div className="valid-feedback">Looks good!</div>
                            </div>
                            <div className="col-xl-4 col-sm-6">
                              <label
                                className="form-label"
                                htmlFor="customLastname"
                              >
                                Cég hozzárendelés
                                <span className="text-danger">*</span>
                              </label>
                              {companies.length > 0 ? (
                                <MultiSelectWithCheckbox
                                  options={companies}
                                  placeholder="Cégek kiválasztása"
                                  onSelectionChange={handleSelectionChange}
                                  selectedOptions={selectedCompanies}
                                  selectedDefault={selectedCompanies}
                                />
                              ) : (
                                <Loading />
                              )}
                              <div className="valid-feedback">Looks good!</div>
                            </div>
                            <div className="col-12 text-end">
                              <button
                                className="btn btn-primary"
                                disabled={sendingLoading}
                              >
                                Mentés
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetail;
